import { render, staticRenderFns } from "./labor-rate-page.vue?vue&type=template&id=6093cf0e&"
import script from "./labor-rate-page.vue?vue&type=script&lang=js&"
export * from "./labor-rate-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports